/* Supports initial load and Shopify's section reloads without duplicate listeners. */
(() => {
  if (window.ruxactyInitialized) return;
  window.ruxactyInitialized = true;
  const hashes = { '#cozy-living': 'cozy', '#everyday-care': 'care', '#home-essentials': 'essentials' };
  function filter(section, category) {
    let shown = 0;
    section.querySelectorAll('[data-rx-category]').forEach(card => {
      card.hidden = category !== 'all' && card.dataset.rxCategory !== category;
      if (!card.hidden) shown++;
    });
    section.querySelectorAll('[data-rx-filter]').forEach(button => {
      const active = button.dataset.rxFilter === category;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    const status = section.querySelector('[data-rx-results]');
    if (status) status.textContent = `${shown} ${shown === 1 ? 'product' : 'products'} shown`;
    const empty = section.querySelector('.rx-filter-empty');
    if (empty) empty.hidden = shown !== 0;
  }
  function applyHash() {
    const category = hashes[location.hash];
    if (category) document.querySelectorAll('[data-rx-finds]').forEach(s => filter(s, category));
    else if (location.hash === '#ruxacty-finds') document.querySelectorAll('[data-rx-finds]').forEach(s => filter(s, 'all'));
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-rx-filter]');
    if (button) filter(button.closest('[data-rx-finds]'), button.dataset.rxFilter);
    const menu = event.target.closest('[data-rx-menu]');
    if (menu && event.target.closest('a')) menu.open = false;
    document.querySelectorAll('[data-rx-menu][open]').forEach(openMenu => {
      if (!openMenu.contains(event.target)) openMenu.open = false;
    });
    const link = event.target.closest('a[href]');
    if (link) {
      const url = new URL(link.href, location.href);
      if (url.origin === location.origin && url.pathname === location.pathname && hashes[url.hash]) {
        document.querySelectorAll('[data-rx-finds]').forEach(s => filter(s, hashes[url.hash]));
      }
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('[data-rx-menu][open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
  });
  window.addEventListener('hashchange', applyHash);
  document.addEventListener('shopify:section:load', applyHash);
  applyHash();
})();
